import { useWorkspaceCurrency } from './useUser';
import { useHasFF } from 'venn-utils';
import { some } from 'lodash';

export function useIsLeverageShortEnabled(): boolean {
  const hasLeverageShortFF = useHasFF('allow_leverage_short_ff');
  const workspaceCurrency = useWorkspaceCurrency();

  return hasLeverageShortFF && workspaceCurrency === 'USD';
}

export function useShouldUseNetAssetsInsteadOfAllocation(): boolean {
  // We want to migrate to net assets for all workspaces, even if it's non-USD, so we don't check the currency here.
  return useHasFF('allow_leverage_short_ff');
}
type HasNegativePositionPortfolio = {
  children: HasNegativePositionPortfolio[];
  netAssets?: number;
  allocation?: number;
};
export const hasNegativePosition =
  (shouldUseNetAssetsInsteadOfAllocation: boolean) =>
  (portfolio: HasNegativePositionPortfolio | undefined): boolean => {
    if (!portfolio) {
      return false;
    }
    const allocation = (shouldUseNetAssetsInsteadOfAllocation ? portfolio.netAssets : portfolio.allocation) ?? 0;
    return allocation < 0 || some(portfolio.children, hasNegativePosition(shouldUseNetAssetsInsteadOfAllocation));
  };

export const useIsLeverageShort = (portfolio: HasNegativePositionPortfolio | undefined): boolean => {
  const shouldUseNetAssetsInsteadOfAllocation = useShouldUseNetAssetsInsteadOfAllocation();
  return hasNegativePosition(shouldUseNetAssetsInsteadOfAllocation)(portfolio);
};
